const routes = {
  '/': 'home',
  '/about': 'about',
  '/work': 'work',
  '/contact': 'contact',
  '/404': 'notfound'
};

import { borderRadGen } from './borderRadGen.js';

export function initRouter() {
  if (!Object.keys(routes).includes(window.location.pathname)) {
    history.replaceState(null, null, '/');
  }

  window.addEventListener('popstate', handleRoute);
  document.body.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-link]');
    if (link) {
      e.preventDefault();
      navigateTo(link.href);
    }

    borderRadGen();
  });
  return handleRoute();
}

function sleep(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

export async function navigateTo(url) {
  history.pushState(null, null, url);
  document.querySelectorAll('.text-cover').forEach(el => el.classList.remove('on'));
  await sleep(1000);
  handleRoute();
}

async function handleRoute() {
  const path = window.location.pathname;
  const page = routes[path] ? routes[path] : (path === '/' ? 'home' : 'notfound');
  const view = await import(`./pages/${page}.js`);
  document.querySelector('#app').innerHTML = '';
  document.querySelector('#app').appendChild(await view.render());
  await sleep(300);
  document.querySelectorAll('.text-cover').forEach(el => el.classList.add('on'));
}
